import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/workspace/node_modules/next-themes/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/workspace/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/workspace/src/app/providers.tsx");
